export enum DifficultyConstants{
    Easy,
    Medium,
    Hard
}